<template>
  <div :style="imgClass" class="water-mark"></div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'WaterMark',
  computed: {
    ...mapGetters(['userInfo']),
    imgClass() {
      return {
        background: `url(${this.getImg(
          this.userInfo.loginName,
          this.userInfo.telNumber
        )}) left top repeat`
      }
    }
  },
  methods: {
    getImg(name, telNumber) {
      const str = name + '-' + telNumber?.slice(-4)
      const canvas = document.createElement('canvas')
      canvas.width = 400
      canvas.height = 200

      const cvs = canvas.getContext('2d')
      cvs.rotate((-20 * Math.PI) / 180)
      cvs.font = '15px Vedana'
      cvs.fillStyle = '#C0C4CC'
      cvs.textAlign = 'left'
      cvs.textBaseline = 'middle'
      cvs.fillText(str, 0, 90)
      cvs.fillText(str, 150, 200)
      return canvas.toDataURL('image/png')
    }
  }
}
</script>

<style lang="less" scoped>
.water-mark {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
  pointer-events: none;
  z-index: 9000;
  opacity: 0.2;
}
</style>
